import React, { Component } from "react";
import { connect } from "react-redux";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "../../../redux/actions/menuActions";
import Menu from "../Menu";
import Conges from "../../../modules/presence/conges/conges";
import AuthRender from "../../../containers/AuthRender";
import { SERVICES } from "../../../configs/constants";

class Home extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("presence");
    this.props.setMenuLeftContent(Menu);
    this.props.setMenuLeftIndex("conges");
    this.props.setMenuLeftItemIndex("");
  }
  render() {
    return (
      <AuthRender service={SERVICES.Conges}>
        <Conges />
      </AuthRender>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(null, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// src/pages/presence/conges/Home.js